import React from 'react'

import { Slider } from '../../../../routes/Home/Old/types'
import { SingleSlide } from '../Slide'

interface Props {
  slider: Slider
  onTransitionEnd: () => void
}

export function Slides({ slider, onTransitionEnd }: Props) {
  if (!slider || !slider?.loaded) {
    return null
  }

  const { slides, currentSlide, nextSlide, transitioning } = slider

  return (
    <>
      {slides?.map((slide, index: number) => (
        <SingleSlide
          key={slide.id}
          active={currentSlide === index}
          next={nextSlide === index}
          url={Object.values(slide.urls).find((url) => !!url)!}
          transitionEndHandler={onTransitionEnd}
          transitioning={transitioning}
          {...slide}
        />
      ))}
    </>
  )
}
